export default __webpack_public_path__ + "static/media/sportya-symbol.b926337e.svg";